<template>
    <router-view></router-view>
</template>

<script lang="ts">
import { configureYupLocale } from '@/utils/yupConfig';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App',
    setup () {
        configureYupLocale();
    }
});
</script>
